export const asString = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

export const asStringArray = (value: unknown): Array<string> | undefined =>
  Array.isArray(value) ? value : undefined;

// For filter params: an empty multi-select means "no filter", so normalize
// [] to undefined to keep it out of API params and query keys.
export const asNonEmptyStringArray = (
  value: unknown,
): Array<string> | undefined => {
  const parsed = asStringArray(value);
  return parsed && parsed.length > 0 ? parsed : undefined;
};

export const asDateISOString = (value: unknown): string | undefined => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString();
  }
  return asString(value);
};

export const asStartOfDayISO = (value: unknown): string | undefined => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const start = new Date(value);
    start.setHours(0, 0, 0, 0);
    return start.toISOString();
  }
  return undefined;
};

export const asInt = (value: unknown): number | undefined => {
  const raw = asString(value);
  if (!raw) {
    return undefined;
  }
  const parsed = Number.parseInt(raw, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const asEnumValue = <T extends Record<string, string>>(
  enumObj: T,
  value: unknown,
): T[keyof T] | undefined => {
  const raw = asString(value);
  return raw && (Object.values(enumObj) as Array<string>).includes(raw)
    ? (raw as T[keyof T])
    : undefined;
};

export const asBooleanFromString = (value: unknown): boolean | undefined => {
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return undefined;
};
